export default __webpack_public_path__ + "static/media/cef35bff7004dd6053ef6f8685585722.svg";